import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { I18nService } from '@recruitee/i18n';

import { ClipboardCopy } from '../../clipboard-copy.service';

@Component({
  selector: 'rt-copy-text-dropdown',
  templateUrl: './copy-text-dropdown.component.html',
  styleUrls: ['./copy-text-dropdown.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyTextDropdownComponent {
  @Input() public text: string = '';
  @Output() public edit: EventEmitter<void> = new EventEmitter();

  constructor(private clipboardCopy: ClipboardCopy, private i18n: I18nService) {}

  public copyToClipboard(): void {
    this.clipboardCopy.fromString(this.text, this.i18n.translate('app.common.copied'));
  }
}
